import { type ReactNode, createContext, useContext } from 'react';
import type { StudioClient } from './client';

const StudioClientContext = createContext<StudioClient | null>(null);

export interface StudioClientProviderProps {
  client: StudioClient;
  children: ReactNode;
}

/**
 * Wraps the React tree with the typed Hono RPC client. Pair with
 * `QueryClientProvider` from `@tanstack/react-query` at the app root.
 */
export function StudioClientProvider({ client, children }: StudioClientProviderProps): ReactNode {
  return <StudioClientContext.Provider value={client}>{children}</StudioClientContext.Provider>;
}

export function useStudioClient(): StudioClient {
  const client = useContext(StudioClientContext);
  if (!client) {
    throw new Error('useStudioClient: missing <StudioClientProvider> ancestor in the React tree');
  }
  return client;
}
